import { BlobServiceClient } from "@azure/storage-blob";

const sanitizeBlobName = (fileName, passGroup) => {
  const maxBlobNameLength = 5120;
  const timestamp = Date.now();

  // 1) Remove any path components (handles "C:\fakepath\file.jpg" and "a/b/file.jpg")
  const lastPart = fileName.split(/[\\/]/).pop() || "upload";

  // 2) Keep last 200 chars (like you do today)
  const trimmed = lastPart.slice(-200);

  // 3) Split ext + base
  const dot = trimmed.lastIndexOf(".");
  const hasExt = dot > 0 && dot < trimmed.length - 1;
  const base = hasExt ? trimmed.slice(0, dot) : trimmed;
  const ext = hasExt ? trimmed.slice(dot + 1).toLowerCase() : "bin";

  // 4) URL-safe normalize (no spaces, no weird chars, no slashes)
  const safeBase = base
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, "-")  // replace unsafe chars
    .replace(/-+/g, "-")            // collapse dashes
    .replace(/^-|-$/g, "")          // trim dashes
    .slice(0, 120) || "upload";

  const safePassGroup = String(passGroup || timestamp)
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 60);

  // 5) Add randomness so names aren't guessable
  const rand = crypto.randomUUID();

  // ✅ Same overall format as before, just safer + random
  const blobName = `${safePassGroup}-${timestamp}-${rand}-${safeBase}.${ext}`;

  return blobName.slice(0, maxBlobNameLength);
}

export async function uploadImage(file, pass, passGroup) {

  const { accountName, containerName, sasToken } = pass.uploadSas;
  const serviceUrl = `https://${accountName}.blob.core.windows.net/?${sasToken}`;
  const blobServiceClient = new BlobServiceClient(serviceUrl);
  const containerClient = blobServiceClient.getContainerClient(containerName);

  const blobName = sanitizeBlobName(file.name, passGroup);
  const blobClient = containerClient.getBlockBlobClient(blobName);
  await blobClient.uploadBrowserData(file, {
    blobHTTPHeaders: { blobContentType: file.type },
    // Optional: metadata/tags (if you want)
    metadata: {
      // passId: "...", (don’t duplicate if it’s already in the path)
      uploadedBy: "anonymous",
    },
  });

  return { blobName, url: blobClient.url.split("?")[0] } // strip SAS

}